export const isUpArrowKey = (keyEvent) => {
    return keyEvent.keyCode === 38;
};

export const isDownArrowKey = (keyEvent) => {
    return keyEvent.keyCode === 40;
};

export const isLeftArrowKey = (keyEvent) => {
    return keyEvent.keyCode === 37;
};

export const isRightArrowKey = (keyEvent) => {
    return keyEvent.keyCode === 39;
};

export const isEnterKey = (keyEvent) => {
    return keyEvent.keyCode === 13;
};
